import { Close } from '@mui/icons-material';
import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import React from 'react';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { ILegalClientLog } from '../../Interfaces/ILegalClientLog';
import { IMetadataLogin } from '../../Interfaces/IMetadataLogin';

interface IProps {
  keyName: string;
  metadataLoginArray: IMetadataLogin[];
  legalClientLogs: ILegalClientLog[];
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const ComposedChartLogin: React.FC<IProps> = ({
  keyName,
  metadataLoginArray,
  legalClientLogs,
  activeDashboard,
  setActiveDashboard,
}) => {
  // Funktion für Browserfarben
  const getBrowserColor = (index: number) => {
    const colors = [
      '#ff5733', // Rote Farbe
      '#33ff57', // Grüne Farbe
      '#3357ff', // Blaue Farbe
      '#ff33a1', // Pinke Farbe
      '#f0e130', // Gelbe Farbe
      '#ff6347', // Tomatenrot
      '#00bfff', // Tiefes Blau
      '#ff1493', // Tiefes Pink
      '#2e8b57', // Meergrün
      '#8a2be2', // Blauviolett
      '#d2691e', // Schokoladenbraun
      '#ff4500', // Orangerot
      '#20b2aa', // Lachsblau
      '#f0f8ff', // Alice Blau
      '#9370db', // Mittelviolett
      '#ff8c00', // Dunkelorange
      '#adff2f', // Grüngelb
      '#00ced1', // Türkisblau
      '#c71585', // Mittelviolettrot
    ];
    return colors[index % colors.length]; // Wiederverwendet Farben, wenn mehr als 18 Browser
  };

  // Funktion für Neonfarben für OS
  const getNeonColor = (index: number) => {
    const neonColors = [
      '#39ff14', // Neon grün
      '#ff073a', // Neon rot
      '#0afff0', // Neon blau
      '#ff7aff', // Neon pink
      '#fffb00', // Neon gelb
    ];
    return neonColors[index % neonColors.length]; // Wiederverwendet Neonfarben, wenn mehr als 5 OS
  };

  const chartData = () => {
    const aktuellesJahr = new Date().getFullYear();
    const resturnArray: any[] = [];

    for (let monat = 0; monat < 12; monat++) {
      const datum = new Date(aktuellesJahr, monat, 1);
      const monatStr = String(monat + 1).padStart(2, '0');

      const currentObject: any = {
        Monat: monatStr,
        Logins: metadataLoginArray.filter(log => {
          const date = new Date(log.Timestamp);
          return (
            date.getFullYear() === datum.getFullYear() &&
            date.getMonth() === datum.getMonth()
          );
        }).length,
        Sperrungen: legalClientLogs
          .filter(log => log.idLegalClientLogType === 4)
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          }).length,
        Entsperrungen: legalClientLogs
          .filter(log => log.idLegalClientLogType === 5)
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          }).length,
        'Passwort zurückgesetzt': legalClientLogs
          .filter(log => log.idLegalClientLogType === 7)
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          }).length,
        Einladungen: legalClientLogs
          .filter(log => log.idLegalClientLogType === 11)
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          }).length,
        'Einladungen angenommen': legalClientLogs
          .filter(log => log.idLegalClientLogType === 12)
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          }).length,
        'Einladungen abgelehnt': legalClientLogs
          .filter(log => log.idLegalClientLogType === 13)
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          }).length,
      };

      resturnArray.push(currentObject);
    }
    return resturnArray;
  };
  /*
  const chartData = () => {
    const aktuellesJahr = new Date().getFullYear();
    const resturnArray: any[] = [];

    for (let monat = 0; monat < 12; monat++) {
      const datum = new Date(aktuellesJahr, monat, 1);
      const monatStr = String(monat + 1).padStart(2, '0');

      const currentObject: any = {
        Monat: monatStr,
        Logins: metadataLoginArray.filter(log => {
          const date = new Date(log.Timestamp);
          return (
            date.getFullYear() === datum.getFullYear() &&
            date.getMonth() === datum.getMonth()
          );
        }).length,
      };

      uniqueBrowsers.map(browser => {
        currentObject[browser] = metadataLoginArray
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          })
          .filter(log => log.Browser === browser).length;
      });
      uniqueOs.map(os => {
        currentObject[os] = metadataLoginArray
          .filter(log => {
            const date = new Date(log.Timestamp);
            return (
              date.getFullYear() === datum.getFullYear() &&
              date.getMonth() === datum.getMonth()
            );
          })
          .filter(log => log.OS === os).length;
      });
      resturnArray.push(currentObject);
    }
    return resturnArray;
  };
  */

  const onRemove = () => {
    setActiveDashboard([...activeDashboard.filter(x => x !== keyName)]);
  };

  return (
    <>
      <Card variant='outlined'>
        <IconButton sx={{ float: 'right' }} onClick={onRemove}>
          <Close sx={{ fontSize: 14 }} />
        </IconButton>
        <CardContent>
          <Typography>Anmeldungen (Monate)</Typography>
          <Box
            sx={{
              mt: 5,
              height: { xs: 150, sm: 250, xl: 300 },
              width: { xs: 300, sm: 375, xl: 450 },
            }}
          >
            <ResponsiveContainer width='100%' height='100%'>
              <ComposedChart data={chartData()}>
                <XAxis dataKey='Monat' />
                <YAxis
                  interval='preserveStartEnd' // Damit wir den Y-Achsenbereich automatisch anpassen können
                  //tickCount={10}  // Anzahl der Ticks auf der Y-Achse (du kannst dies anpassen)
                  tickFormatter={(value: number): string =>
                    Math.floor(value).toString()
                  } // Ganzzahliger Formatter
                />
                <Tooltip />
                <Legend />
                <CartesianGrid stroke='#f5f5f5' />
                <Bar dataKey='Logins' barSize={20} fill='#413ea0' />

                <Line
                  type='monotone'
                  dataKey='Sperrungen'
                  stroke='#ff6347' // Dynamische Browserfarbe
                />
                <Line
                  type='monotone'
                  dataKey='Entsperrungen'
                  stroke='#33ff57'
                />
                <Line
                  type='monotone'
                  dataKey='Passwort zurückgesetzt'
                  stroke='#f0e130'
                />
                <Line type='monotone' dataKey='Einladungen' stroke='#20b2aa' />
                <Line
                  type='monotone'
                  dataKey='Einladungen angenommen'
                  stroke='#adff2f'
                />
                <Line
                  type='monotone'
                  dataKey='Einladungen abgelehnt'
                  stroke='#ff8c00'
                />
              </ComposedChart>
            </ResponsiveContainer>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
